import React from "react";
import { MenuItem, Avatar, Paper, Menu , List,ListItem} from "@material-ui/core";
import {
  ManagePack,
  Notepad,
  ClientNav,
  Employees,
  InvoiceNav,
  NotificationProfile
} from "../../images";
import "./notify-page.scss";
import {
  CONTRACT_ACTION,
  DOCUMENT_ACTION,
  INVOICE_ACTION,
  MASTER_ACTION,
  TIMESHEET_ACTION,
} from "../../redux/action";
import { Toaster, getRolePath } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { dateTimeFormatter } from "../../utils/common";
import {
  getDocumentNotificationRoute,
  getMessageNotificationRoute,
  isDocumentOrFolderNotification,
  isMessageNotification,
} from "../../utils/notificationNavigation";
import {
  enrichNotificationFromDocumentDetail,
  resolveClientDocumentNotification,
  showDocumentUnavailableMessage,
} from "../../utils/documentAvailability";
import { navigateWithClientDetailsGuard } from "../../utils/clientDetailsSession";
import { useStaffNotificationFilter } from "../../hooks/useStaffNotificationFilter";
import { useNotificationFeed } from "../../hooks/useNotificationFeed";

const AllNotifications = (props) => {
  const { visibleNotifications: notifications } = useStaffNotificationFilter();
  const { refresh, loadMore, markReadLocal, hasMore, loadingMore } =
    useNotificationFeed();
  const USER_TYPE = localStorage.getItem("user_role");
  const navigate = useNavigate();
  const [anchor, setAnchor] = React.useState(null);

  useEffect(() => {
    refresh();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageScroll = (event) => {
    const el = event.currentTarget;
    if (!el || loadingMore || !hasMore) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
      loadMore();
    }
  };


  const showAvatar = (type) => {
    switch (type) {
      case "client":
        return ClientNav;
      case "employee":
        return Employees;
      case "contract":
        return Notepad;
      case "invoice":
        return InvoiceNav;
      case "payment":
        return ManagePack;
      case "message":
      case "messages":
        return Notepad;
      default:
        return NotificationProfile;
    }
  };

  const onUpdateNotification = async (notify_data) => {
    const ACTION = {
      folder: [DOCUMENT_ACTION.getFolderDetails, getRolePath("/documents")],
      document: [DOCUMENT_ACTION.getDocumentDetails, getRolePath("/documents")],
      invoice: [
        INVOICE_ACTION.getInvoiceDetail,
        USER_TYPE === "client" ? getRolePath("/payment") : getRolePath("/invoice_contract"),
      ],
      contract: [
        CONTRACT_ACTION.getContractDetail,
        USER_TYPE === "client"
          ? getRolePath("/contract_proposal")
          : getRolePath("/invoice_contract"),
      ],
      timesheet: [
        TIMESHEET_ACTION.getTimesheetEntries,
        getRolePath("/timesheet_dashboard"),
      ],
    };
    const { notification_type, notification_item_id } = notify_data;

    if (isMessageNotification(notify_data)) {
      const route = getMessageNotificationRoute(notify_data, USER_TYPE);
      if (!route) {
        Toaster.error("Could not open message thread");
        return;
      }
      navigateWithClientDetailsGuard(navigate, route.path, { state: route.state });
      try {
        await MASTER_ACTION.updateNotification(notify_data.notification_id);
        markReadLocal(notify_data.notification_id);
      } catch {
        /* best-effort */
      }
      return;
    }

    await MASTER_ACTION.updateNotification(notify_data.notification_id);
    markReadLocal(notify_data.notification_id);

    // Handle timesheet notifications differently - navigate directly with timesheet_id
    if (notification_type === "timesheet") {
      navigate(ACTION.timesheet[1], {
        state: {
          timesheet_id: notification_item_id,
          fromNotification: true,
        },
      });
      return;
    }

    if (isDocumentOrFolderNotification(notify_data)) {
      let enriched = notify_data;

      if (USER_TYPE === "client" && notification_type === "document") {
        const resolved = await resolveClientDocumentNotification(notify_data);
        if (!resolved.ok) {
          showDocumentUnavailableMessage();
          return;
        }
        enriched = resolved.enriched;
      } else if (
        !notify_data.document_category &&
        !notify_data.documentCategory &&
        notification_item_id
      ) {
        try {
          const detailRes =
            notification_type === "document"
              ? await DOCUMENT_ACTION.getDocumentDetails(notification_item_id)
              : await DOCUMENT_ACTION.getFolderDetails(notification_item_id);
          if (detailRes?.status === 200 && detailRes?.data?.data) {
            enriched = enrichNotificationFromDocumentDetail(
              notify_data,
              detailRes,
            );
          }
        } catch {
          /* use notification payload as-is */
        }
      }

      const route = getDocumentNotificationRoute(enriched, USER_TYPE);
      if (!route) {
        Toaster.error("Could not open documents for this client");
        return;
      }
      navigateWithClientDetailsGuard(navigate, route.path, { state: route.state });
      return;
    }

    if (notification_type === "leave") {
      navigate(getRolePath("/dashboard"), {
        state: {
          openLeavePopup: true,
          leave_id: notification_item_id,
        },
      });
      return;
    }

    // Check if ACTION exists for this notification type
    if (!ACTION[notification_type]) {
      Toaster.error("Unknown notification type");
      return;
    }

    // For other types, fetch details first
    const response = await ACTION[notification_type][0](notification_item_id);
    if (response.status === 200) {
      navigate(ACTION[notification_type][1], {
        state: {
          client_id: response.data.data.billed_to,
          mode: notification_type,
          data: response.data.data,
          view: true,
        },
      });
    } else {
      Toaster.error("Error occurred while direction");
    }
  };

  return (
    <Paper className="notify-all-paper">
    <div className="notify-all-scroll" onScroll={handlePageScroll}>
    <List>
      {notifications && notifications.length > 0 ? (
        notifications.map((option, index) => (
          <ListItem
            button
            key={option?.notification_id ?? index}
            onClick={() => onUpdateNotification(option)}
            className={`${
              option?.view_status === "Not Viewed" ? "notify-unread-menuitem" : ""
            } notify-border`}
          >
            <div className="notify-tile">
              <Avatar
                alt={option.notification_type}
                src={showAvatar(option.notification_type)}
                className="notify-avatar"
              />
              <div className="message-tile">
                <div className="notify-message notify-all-message">
                  {option.message}
                </div>
                <div className="notify-time">
                  {dateTimeFormatter(option.createdAt)}
                </div>
              </div>
            </div>
          </ListItem>
        ))
      ) : (
        <ListItem>
          <div className="notify-tile">
            <div className="notify-message notify-all-message">
              {hasMore || loadingMore
                ? "Loading notifications…"
                : "No notifications available."}
            </div>
          </div>
        </ListItem>
      )}
    </List>
    {loadingMore ? (
      <div className="notify-all-status">Loading more…</div>
    ) : null}
    </div>
  </Paper>
  );
};

export default AllNotifications;
